<template>
  <div class="industry-container">
    <h1 class="title">Industries We Serve</h1>
    <div class="chiclet-grid">
      <div
          v-for="industry in industries"
          :key="industry.name"
          class="chiclet">
<!--          @click="navigateTo(industry.route)"-->
<!--      >-->
        <component :is="industry.animation" class="animated-icon" />
        <p class="industry-name">{{ industry.name }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
// import { useRouter } from 'vue-router'

// Import **detailed** SVG animations
import HealthcareMotion from '@/assets/icons/HealthcareMotion.vue'
import FinanceMotion from '@/assets/icons/FinanceMotion.vue'
import ManufacturingMotion from '@/assets/icons/ManufacturingMotion.vue'
import LogisticsMotion from '@/assets/icons/LogisticsMotion.vue'
import InsuranceMotion from '@/assets/icons/InsuranceIcon.vue'

// const router = useRouter()

const industries = [
  { name: "Healthcare", route: "/industry/healthcare", animation: HealthcareMotion },
  { name: "Finance", route: "/industry/finance", animation: FinanceMotion },
  { name: "Manufacturing", route: "/industry/manufacturing", animation: ManufacturingMotion },
  { name: "Logistics", route: "/industry/logistics", animation: LogisticsMotion },
  { name: "Insurance", route: "/industry/insurance", animation: InsuranceMotion },

]

// const navigateTo = (route) => {
//   router.push(route)
// }
</script>

<style scoped>
.industry-container {
  max-width: 1200px;
  margin: auto;
  padding: 20px;
  text-align: center;
}

.title {
  font-size: 2rem;
  margin-bottom: 20px;
  color: white; /* Ensure title is visible */
}

.chiclet-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  justify-content: center;
}

.chiclet {
  background: #f4f4f4;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 150px;
}

.chiclet:hover {
  background: #e0e0e0;
  transform: scale(1.05);
}

.animated-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.industry-name {
  font-size: 1rem;
  font-weight: bold;
  color: #333; /* Ensure readable text */
}
</style>
